import React from 'react';
import { Col, Row} from 'reactstrap';
import { connect } from 'react-redux';
import { SettingAction } from 'redux/actions';
import { checkPermissions } from 'hooks';
import AppForceUpdate from './app-force-update';
import EnrichmentSettings from './enrichment-settings';

const AdminSettings = (props) => {
    return (
        <div>
            {
                (checkPermissions(props.loginData, 'change_enrichment_settings')) ?
                    <Row>
                        <Col>

                            <EnrichmentSettings />
                        </Col>
                    </Row>
                    : ''
            }
            {
                (checkPermissions(props.loginData, 'get_app_version')) ?
                    <Row>
                        <Col>

                            <AppForceUpdate />
                        </Col>
                    </Row>
                    : ''
            }
        </div>
    );
}

const mapStateToProps = (state) => ({


    settingSaved: (state.setting && state.setting.settingSaved) ? state.setting.settingSaved : null,

    settingData: (state.setting && state.setting.settingData && state.setting.settingData.data) ? state.setting.settingData.data : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getSetting: (payload) => dispatch(SettingAction.getSetting(payload)),
    saveSetting: (payload) => dispatch(SettingAction.saveSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminSettings);

